import React from 'react';
import '../App.css';
import Categories from '../components/Categories/Categories';

function Merch () {
    return (
        <>
            <h1 className='merch'>MERCH</h1>
            <Categories />
        </>
    )
}

export default Merch;